export const styles = {
  container: "hyam-slice-container relative",
};

export type S01ContactHeroDefaultStyles =
  typeof styles;
